import React from 'react';

export const CircleCheckMarkSvg = (props) => {

  const { width, height, color } = props;

  return (
    <svg width={width ?? "15"} height={height ?? "16"} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_12756_25687)">
        <path d="M7.92431 13.8936C11.1806 13.8936 13.8203 11.2538 13.8203 7.99756C13.8203 4.74129 11.1806 2.10156 7.92431 2.10156C4.66805 2.10156 2.02832 4.74129 2.02832 7.99756C2.02832 11.2538 4.66805 13.8936 7.92431 13.8936Z" fill={color ?? "#04333B"} stroke={color ?? "#04333B"} strokeWidth="2.83008" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.1417 6.61277L7.40754 10.3469C7.2739 10.4805 7.10095 10.5434 6.92014 10.5434C6.74719 10.5434 6.57424 10.4805 6.4406 10.3469L4.5696 8.48376C4.30232 8.20862 4.30232 7.77624 4.5696 7.50896C4.83689 7.24167 5.27712 7.24167 5.54441 7.50896L6.92014 8.88469L10.1669 5.63796C10.4342 5.37068 10.8744 5.37068 11.1417 5.63796C11.409 5.91311 11.409 6.34548 11.1417 6.61277Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_12756_25687">
          <rect x="0.849609" y="0.921875" width="14.1504" height="14.1504" rx="7.07519" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}